import { API_REQUEST } from "../..";
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  coachBookedWebinarAPI,
  coachCategoriesAPI,
  coachSignUpAPI,
  coachToggleWorkshopStatusAPI,
  coachVerifyCreatePasswordEndPointURL,
  coachWebinarAPI,
  commonBootcamps,
  contactUsAPI,
  createCoachSpeakerImageAPI,
  createCoachWebinarAPI,
  createCoachWorkshopAPI,
  createCoachWorkshopSpeakerImageAPI,
  deleteCoachWebinarAPI,
  deleteCoachWorkShopAPI,
  fetchAllCoachEBookListEndPointURL,
  fetchAllCoachWorkshopEndPointURL,
  fetchAllWebinarAPI,
  fetchNuterrasAPI,
  forgotPasswordAPI,
  getAllCoachEBookListEndPointURL,
  getAllSubscriptionPlanAPI,
  getAllWorkshopPublicAPI,
  getCoachByIdEndPointURL,
  loginAPI,
  purchaseBootCampAPI,
  purchaseSubscriptionAPI,
  reserveSpotAPI,
  setPasswordAPI,
  shareOtpAPI,
  updateCoachSpeakerImageAPI,
  updateCoachWebinarAPI,
  updateCoachWorkshopAPI,
  updateCoachWorkshopSpeakerImageAPI,
  waitListBootCampAPI,
  webinarAPI,
  workshopAPI,
  workshopBookingsAPI,
} from "../../../../routes/apiurls";

// import { coachCategoriesAPI, coachSignUpAPI, coachWebinarAPI, commonBootcamps, contactUsAPI, createCoachSpeakerImageAPI, createCoachWebinarAPI, deleteCoachWebinarAPI, fetchAllWebinarAPI, forgotPasswordAPI, getAllSubscriptionPlanAPI, loginAPI, purchaseBootCampAPI, purchaseSubscriptionAPI, setPasswordAPI, shareOtpAPI, updateCoachSpeakerImageAPI, updateCoachWebinarAPI, waitListBootCampAPI, webinarAPI, workshopAPI } from "../../../../routes/apiurls";
import { setToken } from "../../../../utils/pip";

// register-today
export const registerToday = createAsyncThunk(
  "register-today",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: webinarAPI,
        method: "POST",
        data: payload,
        isSuccessToast: false,
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);
// contact-us
export const contactUs = createAsyncThunk("contact-us", async (props) => {
  const { payload, callback } = props;
  try {
    const response = await API_REQUEST({
      url: contactUsAPI,
      method: "POST",
      data: payload,
      isSuccessToast: false,
      isErrorToast: false,
    });
    callback(response);
    return response;
  } catch (error) {
    callback(null, error);
  }
});

// auth-signin
export const authSignin = createAsyncThunk("auth-signin", async (props) => {
  const { payload, callback } = props;
  try {
    const response = await API_REQUEST({
      url: loginAPI,
      method: "POST",
      data: payload,
    });
    callback(response);
    return response;
  } catch (error) {
    callback(null, error);
  }
});

export const authForgotPassword = createAsyncThunk(
  "auth-forgot-password",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: forgotPasswordAPI,
        method: "POST",
        data: payload,
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);

export const shareOtp = createAsyncThunk("share-otp", async (props) => {
  const { payload, callback } = props;
  try {
    const response = await API_REQUEST({
      url: shareOtpAPI,
      method: "POST",
      data: payload,
    });
    callback(response);
    return response;
  } catch (error) {
    callback(null, error);
  }
});

export const setPassword = createAsyncThunk("set-password", async (props) => {
  const { payload, callback } = props;
  try {
    const response = await API_REQUEST({
      url: setPasswordAPI,
      method: "POST",
      data: payload,
    });
    callback(response);
    return response;
  } catch (error) {
    callback(null, error);
  }
});

export const fetchCoachCategories = createAsyncThunk(
  "fetch-couch-categories",
  async (props) => {
    try {
      const response = await API_REQUEST({
        url: coachCategoriesAPI,
        method: "GET",
        isSuccessToast: false,
      });
      return response;
    } catch (error) { }
  }
);

export const handleCoachSignUp = createAsyncThunk(
  "coach-signup",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: coachSignUpAPI,
        method: "POST",
        data: payload,
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);

export const handlePurchasePlanData = createAsyncThunk(
  "coach-puchase-plan",
  async () => {
    try {
      const response = await API_REQUEST({
        url: getAllSubscriptionPlanAPI,
        method: "GET",
      });
      return response;
    } catch (error) { }
  }
);

export const handlePurchasePlanCoach = createAsyncThunk(
  "coach-purchase",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: purchaseSubscriptionAPI,
        method: "POST",
        data: payload,
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);

export const fetchBootCamps = createAsyncThunk("fetch-bootcamps", async () => {
  try {
    const response = await API_REQUEST({
      url: commonBootcamps,
      method: "GET",
    });
    return response;
  } catch (error) { }
});

export const handlePurchaseBootCamp = createAsyncThunk(
  "purchase-bootcamp",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: purchaseBootCampAPI,
        method: "POST",
        data: payload,
        isSuccessToast: false,
        isErrorToast: false,
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);

// handlePurchaseBootCamp

export const handleWaitListBootCamp = createAsyncThunk(
  "wait-list-bootcamp",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: waitListBootCampAPI,
        method: "POST",
        data: payload,
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);

export const fetchWebinarData = createAsyncThunk("fetch-webinar", async () => {
  try {
    const response = await API_REQUEST({
      url: fetchAllWebinarAPI,
      method: "GET",
    });
    return response;
  } catch (error) { }
});
export const fetchNuterras = createAsyncThunk("fetch-Nuterras", async () => {
  try {
    const response = await API_REQUEST({
      url: fetchNuterrasAPI,
      method: "GET",
    });
    return response;
  } catch (error) { }
});

export const fetchCoachWebinar = createAsyncThunk(
  "fetch-coach-webinar",
  async () => {
    try {
      const response = await API_REQUEST({
        url: coachWebinarAPI,
        method: "GET",
      });
      return response;
    } catch (error) { }
  }
);

export const fetchCoachBookedWebinar = createAsyncThunk(
  "fetch-coach-booked-webinar",
  async () => {
    try {
      const response = await API_REQUEST({
        url: coachBookedWebinarAPI,
        method: "GET",
      });
      return response;
    } catch (error) { }
  }
);

export const addWebinarData = createAsyncThunk("add-webinar", async (props) => {
  const { payload, callback } = props;
  try {
    const response = await API_REQUEST({
      url: createCoachWebinarAPI,
      data: payload,
      method: "POST",
      isSuccessToast: false,
    });
    callback(response);
    return response;
  } catch (error) {
    callback(null, error);
  }
});

export const updateWebinarData = createAsyncThunk(
  "update-webinar",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: updateCoachWebinarAPI,
        data: payload,
        method: "PATCH",
        isSuccessToast: false,
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);

export const updateSpeakerImageData = createAsyncThunk(
  "update-speaker",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: updateCoachSpeakerImageAPI,
        data: payload,
        method: "PATCH",
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);

export const createCoachSpeakerImageData = createAsyncThunk(
  "add-speaker",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: createCoachSpeakerImageAPI,
        data: payload,
        method: "POST",
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);

export const deleteWebinar = createAsyncThunk(
  "delete-webinars",
  async (props) => {
    const { callback, payload } = props;
    try {
      const response = await API_REQUEST({
        url: deleteCoachWebinarAPI + payload,
        method: "DELETE",
      });
      callback(response);
      return response;
    } catch (error) { }
  }
);

export const deleteWorkShop = createAsyncThunk(
  "delete-workshop",
  async (props) => {
    const { callback, payload } = props;
    try {
      const response = await API_REQUEST({
        url: deleteCoachWorkShopAPI + payload,
        method: "DELETE",
      });
      callback(response);
      return response;
    } catch (error) { }
  }
);

// getAllWorkshopPublicAPI
export const getAllPublicWorkshop = createAsyncThunk(
  "fetch-public-workshop",
  async () => {
    try {
      const response = await API_REQUEST({
        url: getAllWorkshopPublicAPI,
        method: "GET",
      });
      return response;
    } catch (error) { }
  }
);

export const fetchWorkshop = createAsyncThunk("fetch-workshop", async () => {
  try {
    const response = await API_REQUEST({
      url: workshopAPI,
      method: "GET",
      isSuccessToast: false,
    });
    return response;
  } catch (error) {
    console.log({ error });
  }
});
export const fetchWorkshopBookings = createAsyncThunk("fetch-workshop-bookings", async () => {
  try {
    const response = await API_REQUEST({
      url: workshopBookingsAPI,
      method: "GET",
      isSuccessToast: false,
    });
    return response;
  } catch (error) {
    console.log({ error });
  }
});

export const createCoachWorkshopSpeakerImageData = createAsyncThunk(
  "add-coach-workshop-speaker",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: createCoachWorkshopSpeakerImageAPI,
        data: payload,
        method: "POST",
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);

export const addCoachWorkshopData = createAsyncThunk(
  "add-coach-workshop",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: createCoachWorkshopAPI,
        data: payload,
        method: "POST",
        isSuccessToast: false,
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);

export const updateCoachWorkshopSpeakerImageData = createAsyncThunk(
  "update-coach-workshop-speaker",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: updateCoachWorkshopSpeakerImageAPI,
        data: payload,
        method: "PATCH",
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);

export const updateCoachWorkshopData = createAsyncThunk(
  "update-coach-workshop",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: updateCoachWorkshopAPI,
        data: payload,
        method: "PATCH",
        isSuccessToast: false,
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);

// Coach E-Book
export const getAllEBooksListCoach = createAsyncThunk(
  "fetch-coach-ebook",
  async (props) => {
    try {
      const { payload } = props;
      const response = await API_REQUEST({
        url: fetchAllCoachEBookListEndPointURL + payload,
        method: "GET",
      });
      return response;
    } catch (error) { }
  }
);

// Get Coach By ID
export const getCoachDataByID = createAsyncThunk(
  "fetch-coach-by-id",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: getCoachByIdEndPointURL + payload,
        method: "GET",
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null);
    }
  }
);

// getCoachEBookByID
export const getCoachEBookByID = createAsyncThunk(
  "fetch-coach-ebook-coach-id",
  async (props) => {
    const { payload } = props;
    try {
      const response = await API_REQUEST({
        url: getAllCoachEBookListEndPointURL + payload,
        method: "GET",
      });
      return response;
    } catch (error) { }
  }
);

// Coach WorkShop

export const getAllCoachWorkshopByCoachId = createAsyncThunk(
  "get-workshop-by-coach-id",
  async (props) => {
    try {
      const { payload } = props;
      const response = await API_REQUEST({
        url: fetchAllCoachWorkshopEndPointURL + payload,
        method: "GET",
      });
      return response;
    } catch (error) { }
  }
);

export const reserveSpot = createAsyncThunk("reserve-spot", async (props) => {
  const { payload, callback } = props;
  try {
    const response = await API_REQUEST({
      url: reserveSpotAPI,
      data: payload,
      method: "POST",
    });
    callback(response);
    return response;
  } catch (error) {
    callback(null, error);
  }
});


export const toggleWorkShopStatus = createAsyncThunk("toggle-workshop-status", async (props) => {
  const { callback, id } = props;
  try {
    const response = await API_REQUEST({
      url: coachToggleWorkshopStatusAPI + id,
      method: "PATCH",
    });
    callback(response);
    return response;
  } catch (error) {
    callback(null, error);
  }
});


export const createCoachPassword = createAsyncThunk("verify-coach-password", async (props) => {
  const { callback, id, payload } = props;
  try {
    const response = await API_REQUEST({
      url: coachVerifyCreatePasswordEndPointURL + id,
      method: "POST",
      data: payload
    });
    callback(response);
    return response;
  } catch (error) {
    callback(null, error);
  }
});